import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchStaffAttendancesPage,
    selectStaffAttendances,
} from '../features/attendance/staff-attendance.slice';
import { getDefaultStaffAttendanceSearchCriteria } from '../service/model/staff-attendance.model';

const useStaffAttendance = () => {
    const dispatch = useAppDispatch();
    const staffAttendances = useAppSelector(selectStaffAttendances);

    const getStaffAttendancePage = async () => {
        await dispatch(fetchStaffAttendancesPage(getDefaultStaffAttendanceSearchCriteria()));
    };

    useEffect(() => {
        if (staffAttendances.length === 0) {
            getStaffAttendancePage();
        }
    }, []);

    return [staffAttendances];
};

export default useStaffAttendance;
